import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import {PageEvent} from '@angular/material/paginator';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
import { UserService } from 'src/app/_service/user.service';
declare var $: any;
@Component({
  selector: 'app-edit-lead',
  templateUrl: './edit-lead.component.html',
  styleUrls: ['./edit-lead.component.css']
})
export class EditLeadComponent implements OnInit {

	leadForm: FormGroup;
    loading:boolean=false;myrole:string;
    leadStatus=[];bds=[];loaded:boolean=false;circles=[];cities=[];
    treatments=[];circle:any;lead_sources=[];
    submitted:boolean=false;lead_bd:boolean=true;cities_copy=[];treatments_copy=[];leadStatus_copy=[];user_lead_source='';
    circles_copy=[];bds_copy=[];doctorList=[];doctorList_copy=[];lead_source_style="block";lead_owner_style="block"; duplicatenumberError:boolean=false;leadSubCat=[];mdSpokUsers=[];checkLeadData=[];affiliateUsers=[];affiliateUsers_copy=[];
   	constructor(private formBuilder: FormBuilder, private leadapi:LeadsService,private sharedapi:SharedService,private router:Router, private route:ActivatedRoute,private userapi:UserService)
    {	
        //console.log(router.url);
    	this.sharedapi.getRole()
        .subscribe((item:string) => {this.myrole=item;});
        this.myrole = localStorage.getItem('role');

        this.sharedapi.getLeadSourceOfUser()
        .subscribe((item:string) => {this.user_lead_source=item;});
        this.user_lead_source = localStorage.getItem('userLeadSource');

        let contactPattern = "[[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*]*";
    	  this.leadForm = this.formBuilder.group({ 
            'lead_name' : [null, Validators.required],
            'mobile' : [null, Validators.compose([Validators.required, Validators.pattern(contactPattern)])],
            'circle_id' : [null, Validators.required],
            'city_id' : [null, Validators.required],
            'doctor' : [null],
            'user_id' : [null, Validators.required],
            'treatment_id' : [null, Validators.required],
            'description' : [null],
            'lead_status_id' : [1, Validators.required],
            'followup_date' : [null],
            'payment_mode' : [null],
            'lead_source' : [null, Validators.required],
            'referral_type' : [null],
            'referral_name' : [null],
            'referral_mobile' : [null],
            'md_spok' : [null],
            'affiliate_id':[null]
        });

        this.leadSubCat=[
            {
            'id':1,
            'name':'Doctor Refferal',
            },
            {
            'id':2,
            'name':'Employee Refferal',
            },
            {
            'id':3,
            'name':'Others Refferal',
            },
            {
            'id':4,
            'name':'Patient Refferal',
            },
            {
            'id':5,
            'name':'PX Refferal',
            },
            {
            'id':6,
            'name':'Diagnostic Refferal',
            },
            {
            'id':7,
            'name':'Lab Refferal',
            },
            {
            'id':8,
            'name':'Phlebotomist Refferal',
            },
            {
            'id':9,
            'name':'City Team Refferal',
            }
        ];
    	
    	/* if(this.myrole=='3'){
	        this.getCircleBds('');
		  } */
        //   else if(this.myrole=='2'){
  		// 	const lead_owner = this.leadForm.get('user_id');
  	    //     lead_owner.clearValidators();
  	    //     lead_owner.updateValueAndValidity();
		//   }
        this.getAllBds();
    }

    checkModelVal() {
        return this.leadForm.controls['mobile'].value == this.leadForm.controls['referral_mobile'].value;
    }

    AddRemoveValidation(event){
        if(event.value==7){
          this.leadForm.controls['referral_name'].setValidators(Validators.required);
          this.leadForm.controls['referral_mobile'].setValidators(Validators.required);
          this.leadForm.controls['referral_type'].setValidators(Validators.required);
        }else{
          this.leadForm.controls['referral_name'].setValidators(null);
          this.leadForm.controls['referral_mobile'].setValidators(null);
          this.leadForm.controls['referral_type'].setValidators(null);
        }
        this.leadForm.controls['referral_name'].updateValueAndValidity();
        this.leadForm.controls['referral_mobile'].updateValueAndValidity();
        this.leadForm.controls['referral_type'].updateValueAndValidity();
        
        if(event.value==32 || event.value==34 || event.value==35 || event.value==89){
            this.getMdSpokUsers(event.value);
        }
        
      }
      

  
 	ngOnInit(): void 
    {
    	this.getcircle();this.getcitiesList();
        this.getleadStatus();this.getTreatment();
        this.getLeadSources();this.getDoctors();
        this.getAffiliateUsers();
        if(this.myrole=='16'){
            this.leadForm.controls['lead_source'].setValue(this.user_lead_source);
            this.leadForm.controls['user_id'].setValue(21);
            this.lead_source_style="none";
            this.lead_owner_style="none";
        }

       
        
    }

    setSearchValue(type){
        if(type=='city'){
            $("#citySearch").val('');
            $("#citySearch").focus();
            this.cities= this.cities_copy;
        }else if(type=='treatment'){
            $("#treatmentSearch").val('');
            $("#treatmentSearch").focus();
            this.treatments= this.treatments_copy;
        }else if(type=='lead_status'){
            $("#lead_status_Search").val('');
            $("#lead_status_Search").focus();
            this.leadStatus= this.leadStatus_copy;
        }else if(type=='circle'){
            $("#circleSearch").val('');
            $("#circleSearch").focus();
            this.circles= this.circles_copy;
        }else if(type=='lead_owner'){
            $("#ownerSearch").val('');
            $("#ownerSearch").focus();
            this.bds= this.bds_copy;
        }else if(type=='doctor'){
            $("#doctorSearch").val('');
            $("#doctorSearch").focus();
            this.doctorList= this.doctorList_copy;
        }else if(type=='affiliate_user'){
            $("#affiliate_userSearch").val('');
            $("#affiliate_userSearch").focus();
            this.affiliateUsers= this.affiliateUsers_copy;
        }
    }

    searchOnSelect(searchtText: string, type){
        if (type == 'city') {
            this.cities = this.sharedapi.searchData(searchtText, this.cities_copy, "name");
        }else  if (type == 'treatment') {
            this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
        }else  if (type == 'lead_status') {
            this.leadStatus = this.sharedapi.searchData(searchtText, this.leadStatus_copy, "name");
        }else  if (type == 'circle') {
            this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
        }else if(type == 'lead_owner'){
             this.bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
        }else if(type == 'doctor'){
            this.doctorList = this.sharedapi.searchData(searchtText, this.doctorList_copy, "name");
        }else if(type == 'affiliate_user'){
            this.affiliateUsers = this.sharedapi.searchData(searchtText, this.affiliateUsers_copy, "name");
        }
    }


    async getCircleBds(circle_id){
        if(this.myrole!='2')
        {
            let qString = 'circle='+circle_id;
            this.leadapi.getcirclewisebds(qString).subscribe((data:any) => {
                if(data.status)
                {
                    this.bds = data.data;
                    this.bds_copy= this.bds;
                    this.lead_bd=false;
                }else{
                    this.bds = [];
                    this.lead_bd=true;
                }
            }, error => {
                this.sharedapi.checkError(error);
            });
        }
    }

    getAllBds()
    {
        if(this.router.url == "/create-partner-lead"){
            let $type = 'partner';
            if(this.myrole=='16')
            {
                $type = "null";
            }
            this.leadapi.getAllBds($type).subscribe((data:any) => {
                if(data.status)
                {
                    this.bds = data.data;
                    this.bds_copy= this.bds;
                    this.lead_bd=false;
                }else{
                    this.bds = [];
                    this.lead_bd=true;
                }
            }, error => {
                this.sharedapi.checkError(error);
            });
        }
        else
        {
            this.leadapi.getAllBds('all').subscribe((data:any) => {
                if(data.status)
                {
                    this.bds = data.data;
                    this.bds_copy= this.bds;
                    this.lead_bd=false;
                }else{
                    this.bds = [];
                    this.lead_bd=true;
                }
            }, error => {
                this.sharedapi.checkError(error);
            });
        }
    }

    getCircleOfCity(city_id)
    {
        this.leadapi.getCircleOfCity(city_id).subscribe((data:any) => {
            this.leadForm.controls['circle_id'].setValue(data.data)
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    get f() { return this.leadForm.controls; }

    async getleadStatus()
    {
        await this.leadapi.getLeadStatus().subscribe((data:any) => {
            if(data.status)
            {
                this.leadStatus = data.data;
                this.leadStatus_copy= this.leadStatus;
            }else{
                this.leadStatus = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getDoctors()
    {
        await this.leadapi.getdoctors().subscribe((data:any) => {
            if(data.status)
            {
                this.doctorList = data.data;
                this.doctorList_copy= this.doctorList;
            }else{
                this.doctorList = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getLeadSources()
    {
        if(this.router.url == "/create-partner-lead"){
            this.leadapi.getPartnerLeadSources().subscribe((data:any) => {
                if(data.status)
                {
                    this.lead_sources = data.data;
                }else{
                    this.lead_sources = [];
                }
            }, error => {
                this.sharedapi.checkError(error);
            });
        }
        else
        {
            this.leadapi.getLeadSources().subscribe((data:any) => {
                if(data.status)
                {
                    this.lead_sources = data.data;
                    if(this.myrole=='17'){
                        var tempArray = [
                            {
                                'id':7,
                                'source_name':'Referral'
                            },
                            {
                                'id':52,
                                'source_name':'Diagnostics'
                            },
                            {
                                'id':53,
                                'source_name':'Diagnostics Camp'
                            }
                        ];
                        this.lead_sources = tempArray;
                        
                        this.leadSubCat=[
                            {
                            'id':6,
                            'name':'Diagnostic Refferal',
                            },
                            {
                            'id':7,
                            'name':'Lab Refferal',
                            }
                        ];
                    }
                }else{
                    this.lead_sources = [];
                }
            }, error => {
                this.sharedapi.checkError(error);
            });
        }
        
    }

    async getcircle()
    {	
        await this.leadapi.getcircles().subscribe((data:any) => {
            if(data.status)
            {
                this.circles = data.data;
                if(this.myrole=='2' || this.myrole=='3')
                {
                    this.leadForm.controls['circle_id'].setValue(data.data[0].id)
                }
                this.circles_copy= this.circles;
            }else{
                this.circles = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getcitiesList()
    {
        await this.leadapi.getcities().subscribe((data:any) => {
            if(data.status)
            {
                this.cities = data.data;
                this.cities_copy= this.cities;
            }else{
                this.cities = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getTreatment()
    {
        await this.leadapi.getTreatments().subscribe((data:any) => {
            if(data.status)
            {
                this.treatments = data.data;
                this.treatments_copy= this.treatments;
            }else{
                this.treatments = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async saveLead(){
        /* console.log(this.leadForm.value);
        console.log(this.leadForm.controls); */
    	this.submitted = true;
        this.loading = true;
        // stop here if form is invalid
        if (this.leadForm.invalid) {
            this.loading = false;
            return;
        }
        
        await this.leadapi.addLead(this.leadForm.value)
         .subscribe((data:any) => {
            this.submitted = false;
            this.loading = false;
            if(data.status)
            {
                this.sharedapi.presentToast('Lead Added Successfully');
                this.router.navigateByUrl('/leads');
                if(this.router.url == "/create-gp-lead"){
                    this.router.navigateByUrl('/gp-leads');
                } 
                else if(this.router.url == "/create-partner-lead"){
                    this.router.navigateByUrl('/partner-leads');
                } 
                else {
                    this.router.navigateByUrl('/leads');
                }
                
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error => 
            {
                this.sharedapi.checkError(error);
            }); 
    }

    async getMdSpokUsers(source)
    {
        await this.leadapi.getMdSpokUsers(source).subscribe((data:any) => {
            if(data.status)
            {
                this.mdSpokUsers = data.data;
            }else{
                this.mdSpokUsers = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async checkMobile()
    {
        let mobile = this.leadForm.controls['mobile'].value;
        let data = {
            'mobile': mobile
          };
        await this.leadapi.checkMobileNumber(data).subscribe((data:any) => {
            if(data.status)
            {
                this.showModal();
                this.checkLeadData = data.data;
            }else{
                this.checkLeadData = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    hideModal()
    {
        $('#myModal').modal('hide');
    }

    showModal()
    {
        $('#myModal').modal();
    }
    
    async getAffiliateUsers()
    {
        await this.userapi.getActiveAffiliateUsers().subscribe((data:any) => {
            if(data.status)
            {
                this.affiliateUsers = data.data;
                this.affiliateUsers_copy = this.affiliateUsers;
            }else{
                this.affiliateUsers = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

}
